module.exports = __webpack_public_path__ + "img/birthEngraving@2x.3e74745.jpg";